const benefits = [
  { icon: 'ri-sun-line', title: 'Commercial Solar', desc: 'Reduce operating costs with tailored commercial solar systems for your business.' },
  { icon: 'ri-battery-charge-line', title: 'Battery Storage', desc: 'Improve energy resilience and manage peak demand charges with commercial batteries.' },
  { icon: 'ri-car-line', title: 'Fleet EV Charging', desc: 'Scalable EV charging infrastructure for business fleets and employee vehicles.' },
  { icon: 'ri-dashboard-line', title: 'Energy Management', desc: 'Monitor, optimise and control your business energy usage through a single dashboard.' },
  { icon: 'ri-bank-card-line', title: 'Finance & ROI Guidance', desc: 'Understand payback periods, access green finance and maximise available rebates.' },
  { icon: 'ri-bar-chart-line', title: 'Demand Management', desc: 'Reduce peak demand charges and participate in demand response programs.' },
];

export default function ForBusinesses() {
  return (
    <section id="businesses" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="order-2 lg:order-1 relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Australian%20commercial%20office%20building%20with%20extensive%20solar%20panel%20array%20on%20flat%20roof%20visible%20from%20drone%20perspective%20surrounded%20by%20green%20landscaping%20and%20native%20trees%20electric%20fleet%20vehicles%20parked%20with%20charging%20stations%20professional%20corporate%20architecture%20bright%20sunny%20day%20sustainable%20business%20photography&width=1000&height=800&seq=business-visual&orientation=landscape"
                alt="Modern Australian commercial building with solar panels, fleet EV charging and sustainable energy solutions"
                className="w-full h-auto rounded-2xl"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-white rounded-xl px-4 py-3 flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center">
                <i className="ri-building-4-line text-secondary-500 text-xl"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">Commercial Savings</p>
                <p className="text-lg font-bold" style={{ color: '#37A9E0' }}>Up to 40%</p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-block px-3.5 py-1.5 rounded-full bg-secondary-50 border border-secondary-200/50 text-xs font-semibold tracking-wider uppercase text-secondary-700 mb-5">
              For Businesses
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight mb-4" style={{ color: '#111827' }}>
              Energy Solutions For Growing
              <span className="relative ml-2" style={{ color: '#37A9E0' }}>
                Australian Businesses
              </span>
            </h2>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
              AK Energy helps businesses explore renewable energy options that can reduce operating costs, improve resilience and support sustainability goals.
            </p>

            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {benefits.map((b) => (
                <div key={b.title} className="flex items-start gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200 transition-colors">
                  <div className="w-8 h-8 rounded-lg bg-secondary-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${b.icon} text-secondary-500 text-sm`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">{b.title}</h4>
                    <p className="text-xs text-foreground-600 mt-0.5">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="/#enquiry"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-xl bg-secondary-500 text-white hover:bg-secondary-600 transition-all duration-200 cursor-pointer"
            >
              Request a Business Energy Assessment
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}